import * as React from 'react';
import { ListItem } from 'components/Autocomplete';
import CheckboxItem from 'components/Checkbox/CheckboxItem';
import ColorDisplay from 'components/ColorDisplay/ColorDisplay';
import type { Option } from 'components/Autocomplete/Autocomplete.config';

const ColorSearchOption = (
  values: Option[] = [],
  optionTextLimit = 13,
  isMultiple = false
) => (props: React.HTMLAttributes<HTMLLIElement>, newValue: Option) => {
  const isShowToolTip = (flagName?: string) =>
    flagName?.length! > optionTextLimit;

  return (
    <ListItem key={newValue?.iso} tabIndex={0} {...props}>
      {isMultiple ? (
        <CheckboxItem
          title={
            isShowToolTip(newValue?.name as string)
              ? newValue?.name.toString()
              : ''
          }
          value={newValue?.name}
          checked={values.some(item => item?.name === newValue?.name)}
        />
      ) : (
        <ColorDisplay
          {...(newValue as { id: string; name: string; color: string })}
        />
      )}
    </ListItem>
  );
};

export default ColorSearchOption;
